export { CreateComment, CreateComment_postFragment } from './CreateComment';
